import { Component } from '@angular/core';

@Component({
  selector: 'app-mainwhy-egypt',
  templateUrl: './mainwhy-egypt.component.html',
  styleUrl: './mainwhy-egypt.component.scss'
})
export class MainwhyEgyptComponent {

}
